import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import BottomNavigation from "@material-ui/core/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";
import QuestionAnswerIcon from "@material-ui/icons/QuestionAnswer";
import ChatIcon from "@material-ui/icons/Chat";

import TicketsManagerTabs from "../../components/TicketsManagerTabs";
import Ticket from "../../components/Ticket";
import TicketAdvancedLayout from "../../components/TicketAdvancedLayout";

import { TicketsContext } from "../../context/Tickets/TicketsContext";
import { QueueSelectedProvider } from "../../context/QueuesSelected/QueuesSelectedContext";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(theme => ({
    header: {
        // Se preferir ocultar as abas visualmente, descomente a linha abaixo:
        // display: "none",
    },
    content: {
        overflow: "auto"
    }
}));

const TicketAdvanced = () => {
    const classes = useStyles();
    const { ticketId } = useParams();
    // Define option com base no ticketId: 0 se existir (exibe o chat), 1 caso contrário (exibe os atendimentos)
    const [option, setOption] = useState(ticketId && ticketId !== "undefined" ? 0 : 1);
    const { setCurrentTicket } = useContext(TicketsContext);

    // Sempre que ticketId mudar, ajusta o estado "option"
    useEffect(() => {
        setOption(ticketId && ticketId !== "undefined" ? 0 : 1);
    }, [ticketId]);

    // Na desmontagem, limpa o ticket no contexto
    useEffect(() => {
        return () => {
            setCurrentTicket({ id: null, code: null });
        };
    }, [setCurrentTicket]);

    // Se ticketId existir, retorna o componente Ticket (chat); caso contrário, retorna TicketsManagerTabs
    const renderMessageContext = () => {
        if (ticketId && ticketId !== "undefined") {
            return <Ticket />;
        }
        return <TicketsManagerTabs />;
    };

    return (
        <QueueSelectedProvider>
            <TicketAdvancedLayout>
            <Box className={classes.header}>
  <BottomNavigation
    value={option}
    onChange={(event, newValue) => {
      setOption(newValue);
    }}
    showLabels
    className={classes.root}
  >
    <BottomNavigationAction 
      label="Ticket" 
      icon={<ChatIcon />} 
      style={{ visibility: 'hidden' }}  // deixa invisível
    />
    <BottomNavigationAction 
      label="Atendimentos" 
      icon={<QuestionAnswerIcon />} 
      style={{ visibility: 'hidden' }} // deixa invisível
    />
  </BottomNavigation>
</Box>


                <Box className={classes.content}>
                    {option === 0 ? renderMessageContext() : <TicketsManagerTabs />}
                </Box>
            </TicketAdvancedLayout>
        </QueueSelectedProvider>
    );
};

export default TicketAdvanced;
